import { TCustomRouteObject } from '@/shared/types/router.types';

// Gated by its parent, sreHubRoutes, on the `custom:isDeveloper` claim.
export const apiLatencyRoutes: TCustomRouteObject = {
  path: 'api-latency',
  handle: {
    crumb: {
      label: 'api_latency',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { ApiLatencyRoute } = await import('./api-latency');
        return { Component: ApiLatencyRoute };
      },
    },
  ],
};
